import {
  LIST_PRICE_FILTERS_MESSAGES,
  ListPriceFiltersMessages,
} from "./list-price-filter.messages";
import {
  LIST_PRICE_REQUEST_MESSAGES,
  ListPriceRequestMessages,
} from "./list-price-request.messages";
import { LIST_PRICE_TABLE_MESSAGES, ListPriceTableMessages } from "./list-price-table.messages";
import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";
import { POPOVER_MESSAGES, PopoverMessages } from "../popover.messages";

export type ListPriceMessages = SidebarMessages &
  PopoverMessages &
  ActionButtonMessages &
  ListPriceTableMessages &
  ListPriceRequestMessages &
  ListPriceFiltersMessages & {
    // Title
    pageTitle: string;
    breadCrumbTitle: string;
    listPriceTableTitle: string;
    moreFilters: string;
    lessFilters: string;
    clearFilters: string;
    filter: string;
    //Buttons
    // addListPriceButton: string;
  };

export const LIST_PRICE_MESSAGES: ListPriceMessages = {
  pageTitle: "Lista de Preço",
  breadCrumbTitle: "Lista de Preço",
  listPriceTableTitle: "Listagem de Preço",
  moreFilters: "Mais Filtros",
  lessFilters: "Menos Filtros",
  clearFilters: "Limpar Filtros",
  filter: "Filtrar",

  // addListPriceButton: "Nova Lista de Preço",

  ...LIST_PRICE_TABLE_MESSAGES,
  ...LIST_PRICE_REQUEST_MESSAGES,
  ...LIST_PRICE_FILTERS_MESSAGES,

  ...ACTION_BUTTON_MESSAGES,
  ...POPOVER_MESSAGES,
  ...SIDEBAR_MESSAGES,
};

export default LIST_PRICE_MESSAGES;
